
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3ueMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf; }, function (v) { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf = v; });
var $289fa3fab82a0cd6$export$6503ec6e8aabbaf;
var $289fa3fab82a0cd6$export$f7ad0328861e2f03;
"use strict";
var $289fa3fab82a0cd6$var$mapping = new Map();
function $289fa3fab82a0cd6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$289fa3fab82a0cd6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $289fa3fab82a0cd6$var$resolve(id) {
    var resolved = $289fa3fab82a0cd6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$289fa3fab82a0cd6$export$6503ec6e8aabbaf = $289fa3fab82a0cd6$var$register;
$289fa3fab82a0cd6$export$f7ad0328861e2f03 = $289fa3fab82a0cd6$var$resolve;

});

parcelRegister("1VgMz", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    const hamburgerBtn = document.querySelector(".btn.btn-hamburger");
    const closeBtn = document.querySelector(".btn.navigationDrawer--closeBtn");
    const topNav = document.querySelector(".top-navigation");
    const drawer = document.querySelector(".navigationDrawer");
    // Open drawer → hide top nav, show drawer
    hamburgerBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.add("d-none");
        if (drawer) drawer.classList.remove("d-none");
    });
    // Close drawer → show top nav, hide drawer
    closeBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.remove("d-none");
        if (drawer) drawer.classList.add("d-none");
    });
});

});

parcelRegister("eZzoa", function(module, exports) {
const $aea236adfe947986$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $aea236adfe947986$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $aea236adfe947986$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("dEKS9"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("1ICF9"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("62f2s"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "staflexx.html",
                logoSrc: new URL((parcelRequire("9NNqC"))),
                title: "Staflexx"
            },
            {
                pageUrl: "trakn.html",
                logoSrc: new URL((parcelRequire("7sgkv"))),
                title: "Trakn"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("lXlin"))),
                title: "All Product"
            }
        ]
    };
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$aea236adfe947986$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
        $aea236adfe947986$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("dEKS9", function(module, exports) {
module.exports = new URL("battery-charging.ba1b1745.webp", import.meta.url).toString();

});

parcelRegister("1ICF9", function(module, exports) {
module.exports = new URL("settings-02.d69d69bd.webp", import.meta.url).toString();

});

parcelRegister("62f2s", function(module, exports) {
module.exports = new URL("life-buoy.285e728c.webp", import.meta.url).toString();

});

parcelRegister("9NNqC", function(module, exports) {
module.exports = new URL("Staflexx_favicon.0afb56d6.webp", import.meta.url).toString();

});

parcelRegister("7sgkv", function(module, exports) {
module.exports = new URL("trakn_favicon.ffb5470c.webp", import.meta.url).toString();

});

parcelRegister("lXlin", function(module, exports) {
module.exports = new URL("box.2a34708a.webp", import.meta.url).toString();

});


parcelRegister("j1fKb", function(module, exports) {
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $dd8a52bd9dba4c43$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($dd8a52bd9dba4c43$var$isCookies) $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
else $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $ea1e819e1f6b5a34$exports = {};

(parcelRequire("3ueMA")).register(new URL("", import.meta.url).toString(), JSON.parse('["e2kdD","manage-payroll.23b34168.js","6caN2","battery-charging.ba1b1745.webp","cXG1D","settings-02.d69d69bd.webp","a8sKm","life-buoy.285e728c.webp","fQZJx","Staflexx_favicon.0afb56d6.webp","7y59p","trakn_favicon.ffb5470c.webp","83Igj","box.2a34708a.webp"]'));

parcelRequire("1VgMz");
parcelRequire("eZzoa");
parcelRequire("j1fKb");
// Why Us PreHeading Icon
const $95f53f4a7338cf63$var$whyUsPreHeadingIcon = `<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="32" height="32" rx="16" fill="white" fill-opacity="0.2"/>
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.3337 14.2283C13.7713 13.8583 14.8337 12.5532 14.8337 11C14.8337 9.15907 13.3413 7.66669 11.5003 7.66669C9.65938 7.66669 8.16699 9.15907 8.16699 11C8.16699 12.5532 9.2293 13.8583 10.667 14.2283V23.5C10.667 23.9603 11.0401 24.3334 11.5003 24.3334C11.9606 24.3334 12.3337 23.9603 12.3337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.167 21C18.167 19.4468 19.2293 18.1417 20.667 17.7717V12.6667C20.667 12.4457 20.5792 12.2337 20.4229 12.0774C20.2666 11.9212 20.0547 11.8334 19.8337 11.8334H17.3337C16.8734 11.8334 16.5003 11.4603 16.5003 11C16.5003 10.5398 16.8734 10.1667 17.3337 10.1667H19.8337C20.4967 10.1667 21.1326 10.4301 21.6014 10.8989C22.0703 11.3678 22.3337 12.0036 22.3337 12.6667V17.7717C23.7713 18.1417 24.8337 19.4468 24.8337 21C24.8337 22.841 23.3413 24.3334 21.5003 24.3334C19.6594 24.3334 18.167 22.841 18.167 21Z" fill="white"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1667 21C18.1667 19.4468 19.229 18.1417 20.6667 17.7717V12.6667C20.6667 12.4457 20.5789 12.2337 20.4226 12.0774C20.2663 11.9212 20.0543 11.8334 19.8333 11.8334H17.3333C16.8731 11.8334 16.5 11.4603 16.5 11C16.5 10.5398 16.8731 10.1667 17.3333 10.1667H19.8333C20.4964 10.1667 21.1323 10.4301 21.6011 10.8989C22.0699 11.3678 22.3333 12.0036 22.3333 12.6667V17.7717C23.771 18.1417 24.8333 19.4468 24.8333 21C24.8333 22.841 23.3409 24.3334 21.5 24.3334C19.6591 24.3334 18.1667 22.841 18.1667 21Z" fill="white"/>
</svg>
`;
document.querySelector(".why-us--preHeading-icon").innerHTML += $95f53f4a7338cf63$var$whyUsPreHeadingIcon;
// Service PreHeading Icon
const $95f53f4a7338cf63$var$servicePreHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`;
document.querySelectorAll(".service__feature-consulting .service__feature-consulting--content-preHeading-icon").forEach((el)=>{
    el.innerHTML += $95f53f4a7338cf63$var$servicePreHeadingIcon;
});
document.querySelector(".apps__manage-payroll--left-preHeading-icon").innerHTML += $95f53f4a7338cf63$var$servicePreHeadingIcon;
document.querySelector(".hospitality__feature-consulting--preHeading-icon").innerHTML += $95f53f4a7338cf63$var$servicePreHeadingIcon;
document.querySelector(".faq__feature-consulting--preHeading-icon").innerHTML += $95f53f4a7338cf63$var$servicePreHeadingIcon;
// Arrow Up Icon Button
const $95f53f4a7338cf63$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".btn.btn-talk-us").forEach((el)=>{
    el.innerHTML += $95f53f4a7338cf63$var$arrowUpIcon;
    el.setAttribute("onclick", "location.href = 'contact-us.html';");
});
document.querySelector(".btn.btn-book-demo").innerHTML += $95f53f4a7338cf63$var$arrowUpIcon;
// FAQ
document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el)=>{
    el.querySelector(".faq__feature-consulting--faqItem-header").addEventListener("click", ()=>{
        if (el.classList.contains("active")) el.classList.remove("active");
        else {
            document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el2)=>{
                el2.classList.remove("active");
            });
            el.classList.add("active");
        }
    });
});
const $95f53f4a7338cf63$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $95f53f4a7338cf63$var$chevronDownIcon;
});
const $95f53f4a7338cf63$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $95f53f4a7338cf63$var$hamburgerIcon;
// Modal Integration
const $95f53f4a7338cf63$var$body = document.querySelector("body");
const $95f53f4a7338cf63$var$btnOpenModalIntegration = document.querySelector(".btn.apps__manage-payroll--left-app-btn");
const $95f53f4a7338cf63$var$modalIntegrationEl = document.querySelector(".modal-integration");
const $95f53f4a7338cf63$var$btnCloseModalIntegration = $95f53f4a7338cf63$var$modalIntegrationEl.querySelector(".btn.modal-integration--close-btn");
const $95f53f4a7338cf63$var$overlayModalIntegration = $95f53f4a7338cf63$var$modalIntegrationEl.querySelector(".modal-integration--overlay");
const $95f53f4a7338cf63$var$btnTabElModalIntegration = $95f53f4a7338cf63$var$modalIntegrationEl.querySelectorAll(".modal-integration--tab-button");
const $95f53f4a7338cf63$var$tabContentElModalIntegration = $95f53f4a7338cf63$var$modalIntegrationEl.querySelectorAll(".modal-integration--content-inner");
$95f53f4a7338cf63$var$btnOpenModalIntegration.addEventListener("click", ()=>{
    $95f53f4a7338cf63$var$modalIntegrationEl.classList.add("show");
    $95f53f4a7338cf63$var$body.style.overflow = "hidden";
});
$95f53f4a7338cf63$var$btnCloseModalIntegration.addEventListener("click", ()=>{
    $95f53f4a7338cf63$var$modalIntegrationEl.classList.remove("show");
    $95f53f4a7338cf63$var$body.style.overflow = "scroll";
});
$95f53f4a7338cf63$var$overlayModalIntegration.addEventListener("click", ()=>{
    $95f53f4a7338cf63$var$modalIntegrationEl.classList.remove("show");
    $95f53f4a7338cf63$var$body.style.overflow = "scroll";
});
$95f53f4a7338cf63$var$btnTabElModalIntegration.forEach((el)=>{
    el.addEventListener("click", ()=>{
        $95f53f4a7338cf63$var$btnTabElModalIntegration.forEach((el2)=>{
            el2.classList.remove("active");
        });
        $95f53f4a7338cf63$var$tabContentElModalIntegration.forEach((el2)=>{
            if (el2.getAttribute("data-tab-name") === el.getAttribute("data-tab-name")) el2.classList.add("active");
            else el2.classList.remove("active");
        });
        el.classList.add("active");
    });
});
// Create the observer like the examples above
const $95f53f4a7338cf63$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $95f53f4a7338cf63$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$95f53f4a7338cf63$var$squares.forEach((element)=>$95f53f4a7338cf63$var$observer.observe(element));


//# sourceMappingURL=manage-payroll.23b34168.js.map
